// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"32835fe2","32":"32835fe2","772":"01742100"}[chunkId] + ".css";
};